import { AxiosInstance } from "axios"
import { UserWallet, WalletsOrderTypeRefill } from "./refillTypes"
import { PaymentMethodType } from "../../../../../payments/paymentTypes"
import { MonetaryAmount } from "../../../../../currency/currencyTypes"
import { RefillWalletResponse } from "../../../../../payments/transactionTypes"

export enum WalletsRefill {
    WALLET_REFILL_DETAILS = "wallet-refill-details",
    USER_WALLETS = "user-wallets",
}

export type FetchUserWalletsResponse = Readonly<{
    wallets: Array<UserWallet>
}>

export async function fetchUserWallets(
    { userId }: { userId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchUserWalletsResponse> {
    const url = `/users/${userId}/wallets`

    const response = await axios.get(url, {
        signal,
    })

    return response.data
}

export type FetchUserWalletsDetailsResponse = Readonly<{
    wallet: UserWallet
}>

type FetchUserWalletsDetailsParams = Readonly<{
    // If walletId is 0 (no wallet), backend should handle this gracefully
    userId: number
    acquirerSetupId: number
    walletId: number
}>

export async function fetchUserWalletsDetails(
    { userId, walletId, acquirerSetupId }: FetchUserWalletsDetailsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchUserWalletsDetailsResponse> {
    const url = `/users/${userId}/acquirerSetups/${acquirerSetupId}/wallets/${walletId}`

    const response = await axios.get(url, {
        signal,
    })

    return response.data
}

type CreateWalletsRefillParams = Readonly<{
    userId: number
    acquirerSetupId: number
    walletId: number
    order: {
        orderType: WalletsOrderTypeRefill
        payment: {
            method: PaymentMethodType
        }
        amount?: MonetaryAmount
        refillDetails?: {
            amount: MonetaryAmount
            threshold: MonetaryAmount
        }
        test?: boolean
    }
}>

export async function createWalletsRefill(
    { userId, acquirerSetupId, walletId, order }: CreateWalletsRefillParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<RefillWalletResponse> {
    const url = `/users/${userId}/acquirerSetups/${acquirerSetupId}/wallets/${walletId}/orders`

    const response = await axios.post(
        url,
        { order },
        {
            signal,
        },
    )

    return response.data
}
